module.exports = __webpack_public_path__ + "static/media/privacypolicy.9c738cbd.htm";